import React from "react";
import { XCircle } from "@phosphor-icons/react";
import PropTypes from "prop-types";
import styled from "styled-components";

const TabCloseBtnWrapper = styled.div`
display : flex;
`

const TabCloseButton = ({ tab, activeTab, hoveredTab, closeTab }) => {
  if (tab.id === "0" || tab.id === "1") return null;

  const isActive = activeTab === tab.id;
  const isHovered = hoveredTab === tab.id;

  // ✅ Extracted nested ternary into a separate statement
  let opacity = 0;
  if (isActive) {
    opacity = 1;
  } else if (isHovered) {
    opacity = 0.7;
  }

  const visibility = isActive || isHovered ? "visible" : "hidden";

  return (
    <TabCloseBtnWrapper>
      <XCircle
        size={20}
        color="#7688A3"
        weight="fill"
        onClick={(e) => {
          e.stopPropagation();
          closeTab(tab.id);
        }}
        style={{
          opacity,
          visibility,
          transition: "opacity 0.2s ease, visibility 0.2s ease",
          cursor:"pointer"
        }}
      />
    </TabCloseBtnWrapper>
  );
};

TabCloseButton.propTypes = {
  tab: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  activeTab: PropTypes.string.isRequired,
  hoveredTab: PropTypes.string, // may be null sometimes
  closeTab: PropTypes.func.isRequired,
};

export default TabCloseButton;

 